// ThreadPool.ts
import { GeneratorOptions, Heightmap } from "./generateV2";
import WorkerFn from "./worker.js";

export class ThreadPool {
  private workers: Worker[] = [];
  private availableWorkers: Worker[] = [];

  constructor(size: number) {
    for (let i = 0; i < size; i++) {
      const worker = this.createWorker();
      this.workers.push(worker);
      this.availableWorkers.push(worker);
    }
  }

  public runTask(data: {
    width: number;
    height: number;
    options: GeneratorOptions;
    rootX: number;
    rootY: number;
  }): Promise<[Heightmap, number, number]> {
    return new Promise((resolve, reject) => {
      if (this.availableWorkers.length === 0) {
        setTimeout(() => this.runTask(data).then(resolve).catch(reject), 50);
        return;
      }

      const worker = this.availableWorkers.pop() as Worker;
      worker.onmessage = (event: MessageEvent) => {
        resolve(event.data);
        this.availableWorkers.push(worker);
      };

      worker.postMessage(data);
    });
  }

  private createWorker(): Worker {
    const blob = new Blob(["(" + WorkerFn.toString() + ")()"], {
      type: "application/javascript",
    });
    const url = URL.createObjectURL(blob);
    return new Worker(url);
  }
}
